import React from 'react';

const Timeline = ({ timeheading, journey }) => {
  return (
    <section className="w-full py-8 px-4 flex flex-col items-center">
      <h2 className="text-3xl font-bold text-[#8B2218] text-center mb-8">
        {timeheading}
      </h2>

      <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12 w-full">
        {journey.map((item, index) => (
          <div
            key={index}
            className="relative flex flex-col items-center md:items-start text-center md:text-left p-6 bg-white rounded-2xl shadow-lg w-[90vw] md:w-72 hover:shadow-xl transition-all"
          >
            {/* Day (Centered on mobile) */}
            <h3 className="text-2xl font-bold text-[#578d48] text-center md:text-left">
              {item.day}
            </h3>

            {/* Title (Centered on mobile) */}
            <h4 className="text-xl md:text-2xl font-semibold text-[#E66123] mt-2 text-center md:text-left">
              {item.title}
            </h4>

            {/* Activities - always left aligned */}
            <ul className="mt-3 text-lg text-gray-600 space-y-2 text-left w-full">
              {item.activities.map((activity, idx) => (
                <li key={idx} className="flex items-start gap-2">
                  {activity}
                </li>
              ))}
            </ul>

            {/* Right arrow - visible only on desktop and not for last item */}
            {index < journey.length - 1 && (
              <div className="hidden md:block absolute top-1/2 right-[-40px] transform -translate-y-1/2">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#578d48"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Timeline;
